import React, { useEffect } from "react";
import DisplayField from "./DisplayField";
import { config } from "../../../style";
import ActivityCard from "./ActivityCard";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";

function GroundCard({ item = {}, prepareDocumentData }) {
    const dataRef = React.useRef(null);
    useEffect(() => {
        prepareDocumentData(item.id, dataRef.current);
    }, [item]);
    const getDriverInformation = (item) => {
        let data = [];
        if (item.driverInformation) {
            data.push(`Driver Name: ${item.driverInformation}`);
        }
        if (item.vehicleInformation) {
            data.push(`Vehicle: ${item.vehicleInformation}`);
        }

        if (data.length > 0) {
            return data.join("<br>");
        }
        return "";
    };

    const prepareLeftData = (key, value, order, mainText) => {
        dataRef.current = dataRef.current || {};
        if (mainText) {
            value.value = mainText;
        }
        dataRef.current[key] = { ...value, side: "left", order };
    };
    const prepareRightData = (key, value, order, mainText) => {
        dataRef.current = dataRef.current || {};
        if (mainText) {
            value.value = mainText;
        }
        dataRef.current[key] = { ...value, side: "right", order };
    };
    return (
        <ActivityCard
            label="Ground Transport"
            icon={<DirectionsCarIcon fontSize="small" sx={{ color: config.primaryColor }}></DirectionsCarIcon>}
            subject={item.subject}
            service={item.service}
            date={item.departureStartTimeString}
            timezone={item.departureTimeZoneCode}
            detail={
                <>
                    {/* <DisplayField
                        label="Departure"
                        type="LocationTime"
                        location={item.DepartureLocation}
                        date={item.departureStartTimeString}
                        timezone={item.departureTimeZoneCode}
                        prepareData={(key, value) => prepareLeftData(key, value, 1)}></DisplayField> */}
                    {getDriverInformation(item) && (
                        <DisplayField
                            label="Driver / Vehicle Information"
                            type="ShowMoreText"
                            element={getDriverInformation(item)}
                            prepareData={(key, value) => prepareLeftData(key, value, 2)}></DisplayField>
                    )}

                    {item.locationNotes && (
                        <DisplayField
                            label="Additional Notes"
                            type="ShowMoreText"
                            element={item.locationNotes}
                            prepareData={(key, value) => prepareLeftData(key, value, 3)}></DisplayField>
                    )}
                </>
            }
            rightElement={null}
            // rightElement={
            //     <>
            //         {item.vendorName && (
            //             <DisplayTextBox
            //                 title={"Vendor"}
            //                 value={item.vendorName}
            //                 prepareData={(key, value) => prepareRightData(key, value, 1)}
            //             />
            //         )}
            //         {item.confirmation && (
            //             <DisplayTextBox
            //                 title={"Confirmation #"}
            //                 value={item.confirmation}
            //                 prepareData={(key, value) => prepareRightData(key, value, 2)}
            //             />
            //         )}
            //         {item.vendorPhone && (
            //             <DisplayTextBox
            //                 title={"Phone Number"}
            //                 value={item.vendorPhone}
            //                 prepareData={(key, value) => prepareRightData(key, value, 3)}
            //             />
            //         )}
            //         {item.arrangedBy && (
            //             <DisplayTextBox
            //                 title={"Arranged By"}
            //                 value={item.arrangedBy}
            //                 prepareData={(key, value) => prepareRightData(key, value, 4)}
            //             />
            //         )}
            //     </>
            // }
            ></ActivityCard>
    );
}

export default GroundCard;
